import Skeleton from "antd/lib/skeleton";
import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { createApiClient } from "apiClient";
import { UserRoles } from "constants/roles";
import DOMPurify from "dompurify";

export const Eula: React.FC = () => {
  const {
    data: providerEulaData,
    isFetching: provFetching,
    isLoading: provLoading
  } = useQuery("providerEula", async () => {
    return await createApiClient().getProvidersEULA();
  });

  const {
    data: patientEulaData,
    isFetching: patientFetching,
    isLoading: patientLoading
  } = useQuery("patientEula", async () => {
    return await createApiClient().getPatientsEULA();
  });

  const isTermsLoading = useMemo(
    () => patientFetching || patientLoading || provFetching || provLoading,
    [patientFetching, patientLoading, provFetching, provLoading]
  );

  const userRole = sessionStorage.getItem("userRole");

  const userIsCaregiverOrPatient =
    userRole === UserRoles.CAREGIVER ||
    userRole === UserRoles.CAREGIVERS ||
    userRole === UserRoles.PATIENT;

  const cleanPatientEulaData = DOMPurify.sanitize(patientEulaData);
  const cleanProviderEulaData = DOMPurify.sanitize(providerEulaData);

  return isTermsLoading ? (
    <Skeleton
      active={isTermsLoading}
      loading={isTermsLoading}
      avatar={false}
      paragraph={{ rows: 10 }}
    />
  ) : (
    <>
      {userIsCaregiverOrPatient ? (
        <div dangerouslySetInnerHTML={{ __html: cleanPatientEulaData }} />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: cleanProviderEulaData }} />
      )}
    </>
  );
};
